import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { convertNameToAvatarPlaceholder, getPropertyAddress } from 'helpers';
import { openNotificationsDrawerEffect } from 'store/effects/drawers/notifications';
import { link } from 'settings/navigation/link';
import { setTransactionTasksLastStateEffect } from 'store/effects/transactions';
import styles from './styles.module.scss';
import BaseNotification from '../../../BaseNotification';
import { TaskIcon } from 'components/Icons/TaskIcon';

const TaskGrouped = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    className,
    Ids,
    IsRead,
    CreatedDate,
    Payload,
    groupType,
    title,
    SeverityLevel,
    IsPinned,
  } = props;
  const { summary } = Payload || {};

  const onClickHandler = () => {
    try {
      const urlObj = new URL(Payload.FullLink);

      const pathname = urlObj.pathname;
      const searchParams = Object.fromEntries(urlObj.searchParams);
      const redirectUrl = `${pathname}${
        Object.keys(searchParams).length > 0
          ? `?${new URLSearchParams(searchParams).toString()}`
          : ''
      }`;
      dispatch(openNotificationsDrawerEffect({ open: false }));
      history.replace(redirectUrl);
    } catch (error) {
      console.error('Invalid URL:', error);
    }
  };

  return (
    <div className={classNames(styles.notificationType, className)}>
      <BaseNotification
        ids={Ids}
        isRead={IsRead}
        title={summary}
        date={CreatedDate}
        groupType={groupType}
        onClick={onClickHandler}
        avatarPlaceholder={<TaskIcon />}
        severityLevel={SeverityLevel}
        IsPinned={IsPinned}
      />
    </div>
  );
};

TaskGrouped.propTypes = {
  Ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  Payload: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  IsRead: PropTypes.bool.isRequired,
  CreatedDate: PropTypes.string.isRequired,
  groupType: PropTypes.string.isRequired,
  SeverityLevel: PropTypes.string,
};

TaskGrouped.defaultProps = {
  className: '',
};

export default TaskGrouped;
